<div class="row pt-5">
  <h4 class="mb-0">Statistics</h4>
  <small class="mb-2">After each round</small>
  <hr>
  <div class="col-6 col-md-3 pt-5" *ngFor="let player of players">
    <h5 class="d-flex justify-content-between">{{ player.name }} <span>{{ player.points }}</span></h5>
    <div class="mt-2" *ngFor="let round of player.history">
      <hr>
      <u>Round {{ round.round }}</u>
      <br>
      <small>
        Bets: {{ round.bet }}<br>
        Sets: {{ round.sets }}<br>
        Bags: {{ round.bags }}<br>
      </small>
      <span class="d-flex justify-content-between">
        <u>Points:</u><b> {{ round.score }}</b>
      </span>
    </div>
  </div>
</div>
